module.exports = __webpack_public_path__ + "img/c243aaf.svg";